import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import AccordionFormFonts from './AccordionFormFont'
import AccordionFormStyle from './AccordionFormStyle'
import type { AccordionFormBrandType, AccordionBrandForms } from './accordionTypes'

const FORM_MAP: AccordionBrandForms = {
  [BrandFormEnum.STYLE]: AccordionFormStyle,
  ...AccordionFormFonts,
}

const AccordionFormBrand: AccordionFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(AccordionFormBrand) as typeof AccordionFormBrand
